module.exports = __webpack_public_path__ + "static/curso_axuilios-8b20bb1b1cb72c745e239eef5aebaa14.jpg";